
export default {
  props: {
    data: {type: Object, required: true},
    flat: {type: Boolean, default: false},
  },
  computed: {
    persona() {
      return this.data.cards?.some(x => x.type === 'persona')
    },
    company() {
      return this.data.cards?.some(x => x.type === 'company')
    },
    editable() {
      return this.data.editable
    },
    meeting() {
      return this.data.cards?.some(x => x.type === 'meeting') || !!this.data.file_download
    },
    nothing(){
      return !this.editable && !this.persona && !this.company && !this.meeting
    }
  }
}
